import { createSlice } from "@reduxjs/toolkit";
import { ICalenderEventsSlice } from "../../../models/common/ICalendar";

const initialCalenderEventDetails: ICalenderEventsSlice = {
    calenderEvents: undefined,
    googleCalenderEvents: undefined,
};

const calendarSlice = createSlice({
    name: "calendarSlice",
    initialState: initialCalenderEventDetails,
    reducers: {
        setCalenderEvents: (state, action: { payload: any }) => {
            state.calenderEvents = action.payload;
        },
        setGoogleCalenderEvents: (state, action: { payload: any }) => {
            state.googleCalenderEvents = action.payload;
        },
    },
});

export const { setCalenderEvents, setGoogleCalenderEvents } = calendarSlice.actions;

const calendarReducer = calendarSlice.reducer;

export type CalenderEventsState = ReturnType<typeof calendarReducer>;

export default calendarReducer;